import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../../components/Layout';
import { Button } from '../../../components/ui/Button';
import { Card, CardContent } from '../../../components/ui/Card';
import { FileText } from 'lucide-react';

/**
 * Placeholder for job-linked RAMS list.
 * Shows empty state until the Jobs module exists.
 * Route: /tenant/jobs/:jobId/rams
 */
export default function JobRamsList() {
  const { jobId } = useParams();
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 py-8">
        <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
          <CardContent className="pt-8 pb-8 px-8 text-center">
            <div className="flex justify-center mb-4">
              <div className="rounded-full bg-gray-100 dark:bg-gray-700 p-4">
                <FileText className="h-10 w-10 text-gray-500 dark:text-gray-400" />
              </div>
            </div>
            <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
              Job RAMS
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
              RAMS linked to jobs will appear here when the Jobs module is available.
              Job-linked RAMS can be created and managed from the job once that feature is released.
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-500 mb-6">
              Job ID: {jobId || '—'}
            </p>
            <div className="flex flex-wrap justify-center gap-3">
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate('/tenant/tools/rams')}
              >
                View all RAMS
              </Button>
              <Button
                variant="default"
                size="sm"
                onClick={() => navigate('/tenant/dashboard')}
              >
                Dashboard
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
